import React from "react";
import failureImg from "../img/failureImg.png";
import "../index.scss";
export default function Failure() {
  return (
    <div className="failure-wrapper">
      <img src={failureImg} alt="" />
      <div>抱歉，该披露信息已失效！</div>
    </div>
  );
}
